import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type AvnetSilicaV3LocaleCurrencyDTO = z.infer<typeof AvnetSilicaV3LocaleCurrencyDTORuntype>;
export const AvnetSilicaV3LocaleCurrencyDTORuntype = z.enum(['Eur', 'Usd', 'Gbp', 'Jpy']);

export interface AvnetSilicaV3CredentialsDTO extends z.infer<typeof AvnetSilicaV3CredentialsDTORuntype> {}
export const AvnetSilicaV3CredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    subscription_key: z.string(),
    currency: AvnetSilicaV3LocaleCurrencyDTORuntype.nullable(),
});

export interface AvnetSilicaV3CredentialsInputDTO extends z.infer<typeof AvnetSilicaV3CredentialsInputDTORuntype> {}
export const AvnetSilicaV3CredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    subscription_key: z.string().optional(),
    currency: AvnetSilicaV3LocaleCurrencyDTORuntype.nullable(),
});

export interface AvnetSilicaV3ResponseBodyDTO extends z.infer<typeof AvnetSilicaV3ResponseBodyDTORuntype> {}
export const AvnetSilicaV3ResponseBodyDTORuntype = z.object({
    data: AvnetSilicaV3CredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
